import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { Area } from '@/enums/Area.enum';
import { Stroke, Style } from 'ol/style';
import { LayerName } from '@/enums/LayerName.enum';
import { FILL_TRANSPARENT } from '@/utils/constants.utils';

import data from '@/data/countries.data.json';

export const countriesLayer = new VectorLayer({
	visible: true,
	source: new VectorSource({
		features: new GeoJSON().readFeatures(data, { featureProjection: 'EPSG:3857' }),
	}),
  style: function (feature) {
    const isKosovoPolygon = feature.get('isKosovoPolygon');
    return new Style({
      fill: FILL_TRANSPARENT,
      stroke: new Stroke({
        color: '#FFF',
        width: 1,
        lineDash: isKosovoPolygon ? [5, 10] : undefined,
      }),
    });
  }
});

countriesLayer.setProperties({ area: Area.COUNTRIES, name: LayerName.COUNTRIES });
